

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters, mapState, mapMutations } from 'vuex'

@Component({
  computed: {
    ...mapGetters([
      'name',
      'isAnonymous',
    ]),

    ...mapState([
      'user',
    ]),

    ...mapMutations({
      setUser: 'setUser',
  })
  }
})
export default class App extends Vue {
  @Prop({default: "Ohai"}) private msg!: string;

  private label = "Name: "

  async logout() {
    const response = await this.$http.post('/user/logout');
    this.$store.commit( 'setUser', { user: response.data });
  }

  mounted() {
    this.$http.get('/user/current').then(
      response => {
        this.$store.commit('setUser', { user: response.data });
      }
    )
  }
}
